export enum GradesActions {
  Reset = "reset",
}
